import type { InteractionBlueprintData } from "@/lib/contentParsers/interactionBlueprintSchema";

/** Ensures blueprint JSON carries `fileName` before `prepareBlueprintForEditor` in document/session reducers. */
export const withInteractionBlueprintFileName = (
  blueprint: InteractionBlueprintData,
  fileName: string,
): InteractionBlueprintData => {
  const n = fileName.trim();
  if (n.length === 0) {
    throw new Error(
      "withInteractionBlueprintFileName: fileName must be non-empty",
    );
  }
  if (blueprint.fileName === n) {
    return blueprint;
  }
  return { ...blueprint, fileName: n };
};
